var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcessorderwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/box-time"
  }, /*#__PURE__*/React.createElement("g", {
    id: "box-time"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.6416 6.2002L9.99992 10.4585L17.3082 6.22517",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10 18.0085V10.4502",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.0083 7.64199V12.3587C18.0083 12.4004 18.0084 12.4336 18 12.4753C17.4167 11.967 16.6667 11.667 15.8334 11.667C15.05 11.667 14.325 11.942 13.75 12.4003C12.9834 13.0087 12.5 13.9503 12.5 15.0003C12.5 15.6253 12.675 16.217 12.9833 16.717C13.0583 16.8503 13.15 16.9753 13.25 17.092L11.725 17.9337C10.775 18.467 9.22501 18.467 8.27501 17.9337L3.82502 15.467C2.81668 14.9087 1.9917 13.5087 1.9917 12.3587V7.64199C1.9917 6.49199 2.81668 5.09201 3.82502 4.53368L8.27501 2.06699C9.22501 1.53366 10.775 1.53366 11.725 2.06699L16.175 4.53368C17.1834 5.09201 18.0083 6.49199 18.0083 7.64199Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M19.1667 15.0003C19.1667 16.0003 18.725 16.892 18.0333 17.5003C17.4417 18.017 16.675 18.3337 15.8333 18.3337C13.9917 18.3337 12.5 16.842 12.5 15.0003C12.5 13.9503 12.9833 13.0087 13.75 12.4003C14.325 11.942 15.05 11.667 15.8333 11.667C17.675 11.667 19.1667 13.1587 19.1667 15.0003Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.0417 13.959V15.209L15 15.834",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessorderwhite);
export default __webpack_public_path__ + "static/media/processorderwhite.8b9a3008.svg";
export { ForwardRef as ReactComponent };